import React from 'react';
import { ReactComponent as Burger } from '../../assets/svg/burger.svg';
import cls from 'classnames';

interface IMobileHeaderWrapper {
  onBurgerClick: () => void;
  opened?: boolean;
}

export const MobileHeaderWrapper: React.FC<IMobileHeaderWrapper> = ({ onBurgerClick, opened }) => {
  return (
    <div className={cls('mobile-wrapper', { opened })}>
      <h1>CSCON1</h1>
      <div className="burger center" onClick={onBurgerClick}>
        <Burger className="click-effect" />
      </div>
    </div>
  );
};
